module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338600/result01_sp-35a344fddb0e4581155f93fa1bcee40e.png";